import React from 'react';
import { Route } from 'react-router';
import { Switch } from 'react-router-dom';
import { userHasExpenseEnabledRedir } from '../core/auth';
import ExpensesDetail from '../views/expenseDetail/containers/ExpenseDetail';
import Expenses from '../views/utilities/containers/UtilityTabs';

const UtilitiesRoute = () => {
  return (
    <Switch>
      <Route exact path="/:site/utilities">
        <Expenses />
      </Route>
      <Route path="/:site/utilities/:expense">
        <ExpensesDetail />
      </Route>
    </Switch>
  );
};

export default userHasExpenseEnabledRedir(UtilitiesRoute);
